import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import { faAt, faEnvelope, faPhone, faPhoneAlt, faVoicemail } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef, useCallback } from "react";
import SEO, { pageSEO } from "../components/seo.component";
import aboutHero from "../assets/images/shutterstock_2811192445.jpg";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useUserParams } from "../hooks/useUserParams";

export default function About() {
  const {
    getCurrentAgentName,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentAbout,
    getCurrentHeadshot,
  } = useUserParams();
  const seoConfig = pageSEO.about();

  return (
    <>
      <SEO {...seoConfig} />

      {/* Hero */}
      <section className="relative h-[500px] overflow-hidden">
        <img
          src={aboutHero}
          className="h-full w-full object-cover"
          alt="About"
        />

        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/20" />
      </section>


      {/* About Content */}
      <section className="relative mx-auto max-w-[1600px] px-6 pb-24 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-12 pt-10">

          {/* Agent Profile */}
          <div className="lg:col-span-4 lg:-mt-48 relative z-10">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <img
                src={getCurrentHeadshot()}
                alt={getCurrentAgentName()}
                className="h-[300px] w-full object-cover"
              />
            </div>


            {/* Contact */}
            <div className="mt-8 space-y-4 rounded-2xl bg-white p-6 shadow-xl">
              <p className="flex items-center gap-3 text-summit-primary">
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  className="text-summit-highlight"
                />
                {getCurrentAgentNumber()}
              </p>

              <p className="flex items-center gap-3 text-summit-primary">
                <FontAwesomeIcon
                  icon={faAt}
                  className="text-summit-highlight"
                />
                {getCurrentAgentEmail()}
              </p>
            </div>
          </div>

          {/* About Text */}
          <div className="lg:col-span-8 lg:pt-20">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={stagger}
              className="space-y-8"
            >
              <motion.p
                variants={fadeUp}
                className="uppercase tracking-[0.4em] text-sm text-summit-highlight"
              >
                About
              </motion.p>

              <motion.h2
                variants={fadeUp}
                className="text-4xl font-light uppercase tracking-wider text-summit-primary md:text-5xl"
              >
                {getCurrentAgentName()}
              </motion.h2>

              <motion.div
                variants={fadeUp}
                className="h-[2px] w-24 bg-summit-highlight"
              />

              <motion.p
                variants={fadeUp}
                className="whitespace-pre-line leading-8 text-summit-tertiary"
              >
                {getCurrentAbout()}
              </motion.p>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
}
